import React from "react";
import { Modal } from "react-bootstrap";
import "../../../assets/css/dashboard.css";
import AddRoleForm from 'components/widgets/forms/addRoles/AddRoleFormContainer';
import { ModalContext } from "context/ModalContext";
import AddClientQuotationForm from "../forms/AddClientQuotation";
import Add_Client_Risk from "../forms/Add_Client_Risk";

const AddClientRisk = (props) => {

  return (
       
          <Modal
          show={props.show} 
          onHide={props.onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <h5 className="text-grey">Add Client Risk</h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Add_Client_Risk onRiskAdded={props.onRiskAdded} client_quotation_id={props.client_quotation_id} />
            </Modal.Body>
          </Modal>
        
   
  );
};

export default AddClientRisk;
